// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { ScopedCssBaseline, Tooltip, useMediaQuery } from '@mui/material';
// import { ThemeProvider } from '@mui/system';
// import theme from "../styles/themeStyle";
// import { AppBar, Toolbar, Typography, Button, useTheme, IconButton } from '@mui/material';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// // import logo from "../IMG/logo1.png";
// import Nav from './nav';
// import CartIcon from './CartIcon';
// import { AppbarHeader } from '../styles/headerStyle';
// import PersonIcon from '@mui/icons-material/Person';
// import Search from './Search';
// import LogoutIcon from '@mui/icons-material/Logout';
// import { useDispatch, useSelector } from 'react-redux';
// import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import FavoritesList from './Favorites';
// import logo from "../assets/logo.jpg";

// const Header = () => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const logedUser = useSelector(state => state.user.logedUser);


//   //פונקציה שכאשר המסך קטן התפריט יהיה כלפי מטה
//   const matches = useMediaQuery(theme.breakpoints.down('md'));

//   // State to manage whether the user is logged in
//   // const [isLoggedIn, setIsLoggedIn] = useState(false);

//   // Function to handle logout
//   // const handleLogout = () => {
//   // Implement your logout logic here
//   //   setIsLoggedIn(false);
//   // };
//   return (

//     <AppBar position="fixed" sx={{ justifyContent: 'space-between', padding: '7px', display: 'flex', flexDirection: 'row', alignItems: 'center'  ,borderRadius: 3, }}>
//       <div style={{ display: 'flex' }} >
//         <img style={{ width: 100, height: 50, marginTop: 1 }}
//           className='image'
//           src={logo} alt="logo" />
//         <Search fromNavBar={true}></Search>

//         {/* <Tooltip title="המוצרים שאני אוהב">
//           <IconButton edge="end" component={Link} to="/favorite">
//             <FavoriteIcon color='secondary' />
//           </IconButton>
//         </Tooltip> */}

//       </div>

//       <Nav />
//       <div style={{ display: 'flex', alignItems: 'center' }}>

//         {/* // isLoggedIn ? (
//           //   <Tooltip title="התנתקות">
//           //     <IconButton edge="end" color="inherit" component={Link} to="/signIn" label="התנתק">
//           //       <LogoutIcon style={{ fontSize: 40 }} />
//           //     </IconButton>
//           //   </Tooltip>
//           // ) : */}
//         {logedUser?.tipeUser == "admin" && <Tooltip title=" מנהל מערכת">
//           <Link to="/admin" style={{ color: "inherit" }}>
//             <AdminPanelSettingsIcon style={{ fontSize: 40 }} />
//           </Link>
//         </Tooltip>}
//         {(
//           <Tooltip title="התחברות">
//             <IconButton edge="end" color="inherit" component={Link} to="/signIn">
//               <PersonIcon style={{ fontSize: 40 }} />
//             </IconButton>
//           </Tooltip>
//         )}
//         <Tooltip title="עגלת קניות">
//           <Link to="/cart" style={{ color: "inherit" }}>
//             <CartIcon style={{ fontSize: 40 }} />
//           </Link>
//         </Tooltip>


//         {/* <AppbarHeader>Shine's Stock</AppbarHeader> */}
//       </div>
//     </AppBar>
//   );
// };

// export default Header;
import React from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Container,
  Paper,
  Box,
  Menu,
  MenuItem,
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PersonIcon from "@mui/icons-material/Person";
import CartIcon from "./CartIcon";
import Nav from "./nav";
import Search from "./Search";
import { useDispatch, useSelector } from "react-redux";
import logo from "../assets/logo.jpg";
import ProductList from "./ProductList";
import { logoutUser } from "../features/userSlice";


export default function Header() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const logedUser = useSelector((s) => s.user.logedUser);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openUserMenu = Boolean(anchorEl);

  const handleUserIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    // כאן שימי את הלוגיקה של ההתנתקות
    // לדוגמה:
    dispatch(logoutUser());
    // או dispatch(setLogedUser(null));
    console.log("logout clicked");
    localStorage.removeItem("isAdmin");
    handleUserMenuClose();
  };



  return (
    <>
      {/* לוגו קבוע - מופרד מהסרגל, לא נגלל */}
      {/* <Box
        component="img"
        src={logo}
        alt="logo"
        sx={{
          position: "fixed",
          top: { xs: 8, md: 5 },
          right: { xs: 8, md: 15 },   // להזיז יותר ימינה – הגדילי כאן
          width: { xs: 120, md: 250 },
          height: "auto",
          zIndex: (t) => t.zIndex.appBar + 2,
          pointerEvents: "none",       // שלא יחסום קליקים על הסרגל
        }}
      /> */}

      <Box
        sx={{
          position: "fixed",
          top: { xs: 8, md: 5 },
          right: 0,
          pr: { xs: 2, md: 0 }, // להזיז יותר ימינה – הגדילי כאן
          zIndex: (t) => t.zIndex.appBar + 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 1,
          width: { xs: 200, md: 420 },

        }}
      >
        {/* <Box sx={{ width: "100%" }}>
          <Box
            component="img"
            src={logo}
            alt="logo"
            sx={{
              width: { xs: 30, md: 250 },
              height: "auto",
              pointerEvents: "none", // הלוגו לא יחסום לחיצות
            }}
          />
        </Box> */}

        <Box sx={{ width: "100%" }}>
          {/* החיפוש יושב מתחת ללוגו, עם רוחב נשלט */}
          {/* <Box sx={{ width: { xs: 240, md: 420 } }}>
          <Search fromNavBar={true} />
          </Box> */}
        </Box>
      </Box>

      {/* רווח עליון כדי שלא יהיה חפיפה עם ה־fixed (כווני לפי גובה הלוגו+חיפוש) */}
      {/* <Box sx={{ height: { xs: 120 + 56, md: 250 + 64 } }} /> */}
      <AppBar
        position="sticky"
        color="transparent"
        elevation={0}
        sx={{ bgcolor: "transparent", pt: 1 }}
      >
        <Container maxWidth={false} disableGutters>
          {/* שורה אחת: לוגו + הסרגל המעוגל */}
          <Box sx={{ width: "min(1400px, 100%)", mx: "auto", px: 2 }}>
            {/* הלוגו מחוץ לסרגל */}
            {/* <Box
            component="img"
            src={logo}
            alt="logo"
            sx={{ width: 160, height: 100, display: "block" }}
          /> */}

            {/* הסרגל המעוגל */}
            <Paper
              elevation={6}
              sx={{
                flex: 1,
                borderRadius: 6,
                bgcolor: "#fff",
                overflow: "hidden",
              }}
            >
              <Toolbar
                disableGutters
                sx={{
                  px: { xs: 1, sm: 2 },
                  gap: { xs: 1, sm: 2 },
                  flexwrap: "wrap",
                  justifyContent: "space-between",
                  minHeight: { xs: 48, sm: 56, md: 64 }, // סרגל קטן יותר
                  transition: "min-height 0.3s ease",
                }}
              >
                {/* חיפוש + ניווט + אייקונים כרגיל */}
                {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Search fromNavBar={true} />
              </Box> */}

                <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
                  {/* <Nav /> */}
                  <ProductList></ProductList>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {logedUser?.tipeUser === "admin" && (
                    <Tooltip title="מנהל מערכת">
                      <Link to="/admin" style={{ color: "inherit" }}>
                        <AdminPanelSettingsIcon style={{ fontSize: 36 }} />
                      </Link>
                    </Tooltip>
                  )}
                  {logedUser ? (
                    <>
                      <Tooltip title={logedUser?.name ? `שלום, ${logedUser.name}` : "החשבון שלי"}>
                        <IconButton color="inherit" onClick={handleUserIconClick}>
                          <PersonIcon style={{ fontSize: 36, color: "#58A76B" }} />
                        </IconButton>
                      </Tooltip>

                      <Menu
                        anchorEl={anchorEl}
                        open={openUserMenu}
                        onClose={handleUserMenuClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem onClick={handleLogout}>התנתקות</MenuItem>
                      </Menu>
                    </>
                  ) : (
                    <Tooltip title="התחברות">
                      <IconButton color="inherit" component={Link} to="/signIn">
                        <PersonIcon style={{ fontSize: 36, color: "#58A76B" }} />
                      </IconButton>
                    </Tooltip>
                  )}

                  <Tooltip title="עגלת קניות">
                    <Link to="/cart" style={{ color: "inherit" }}>
                      <CartIcon style={{ fontSize: 36 }} />
                    </Link>
                  </Tooltip>
                </Box>
              </Toolbar>
            </Paper>
          </Box>
        </Container>
      </AppBar>
    </>
  );
}

